export default "__VITE_ASSET__DQySufmd__"